/* eslint-disable react/button-has-type */
import React, { Component, Fragment } from 'react'
import PropTypes from 'prop-types'
import './SearchInput.module.scss'
import { ReactComponent as SearchIcon } from '@assets/svgs/icons/search.svg'
import SearchLoader from './SearchLoader'

export default class SearchInput extends Component {
  componentDidMount () {
    const { location, onInputChange } = this.props
    this.input.focus()

    if (location) {
      const value = decodeURI(location.search.replace('?query=', ''))
      onInputChange({ target: { value } })
    }
  }

  componentDidUpdate (prevProps) {
    const { location, onInputChange } = this.props
    const prevLocation = prevProps.location

    if (prevLocation && prevLocation.search !== location.search) {
      const value = decodeURI(location.search.replace('?query=', ''))
      onInputChange({ target: { value } })
    }
  }

  render () {
    const { onSubmitForm, onInputChange, input, placeholder, showLoader } = this.props
    return (
      <Fragment>
        <form styleName='form' onSubmit={onSubmitForm}>
          <span styleName='search'>
            <input
              type='text'
              id='query'
              name='query'
              placeholder={placeholder || 'Search BSS'}
              value={input}
              onChange={onInputChange}
              styleName='input'
              autoComplete='off'
              ref={(input) => {
                this.input = input
              }}
            />
            <label for='query' class='sr-only'>Search BSS</label>
            <button onClick={this.onSubmitForm} styleName='button'>
              {showLoader ? <SearchLoader /> : <SearchIcon styleName='icon' />}
              <span class='sr-only'>Search</span>
            </button>
          </span>
        </form>
      </Fragment>
    )
  }
}

SearchInput.propTypes = {
  onInputChange: PropTypes.func,
  onSubmitForm: PropTypes.func,
  input: PropTypes.string,
  placeholder: PropTypes.string,
  showLoader: PropTypes.bool
}

SearchInput.defaultProps = {
  onInputChange: () => {},
  onSubmitForm: () => {},
  input: '',
  placeholder: 'Search BSS',
  showLoader: false
}



// WEBPACK FOOTER //
// ./src/components/SearchInput/SearchInput.js